/* tslint:disable */
/* eslint-disable */
/**
 * Lumen Failure Management API
 * <h5>ToDo: API description</h5>
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RolePermissionDto
 */
export interface RolePermissionDto {
    /**
     * 
     * @type {string}
     * @memberof RolePermissionDto
     */
    roleId: string;
    /**
     * 
     * @type {string}
     * @memberof RolePermissionDto
     */
    permission?: string | null;
}

export function RolePermissionDtoFromJSON(json: any): RolePermissionDto {
    return RolePermissionDtoFromJSONTyped(json, false);
}

export function RolePermissionDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): RolePermissionDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'roleId': json['roleId'],
        'permission': !exists(json, 'permission') ? undefined : json['permission'],
    };
}

export function RolePermissionDtoToJSON(value?: RolePermissionDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'roleId': value.roleId,
        'permission': value.permission,
    };
}


